export type ImageFit = 'scale-down' | 'contain' | 'cover' | 'crop' | 'pad';

export interface ImageTransformOptions {
  width?: number;
  height?: number;
  quality?: number;
  fit?: ImageFit;
  format?: 'auto' | 'webp' | 'avif';
}

/**
 * Build a URL for an image stored in R2, optionally requesting a transform.
 * `base` is the image worker origin (e.g. "https://images.example.com"); when
 * empty the result is a root-relative path. With no transform options the URL
 * points at the original object.
 */
export function imageUrl(key: string, opts: ImageTransformOptions = {}, base = ''): string {
  const params = new URLSearchParams();
  if (opts.width) params.set('w', String(opts.width));
  if (opts.height) params.set('h', String(opts.height));
  if (opts.quality) params.set('q', String(opts.quality));
  if (opts.fit) params.set('fit', opts.fit);
  if (opts.format) params.set('format', opts.format);

  const path = `${base.replace(/\/$/, '')}/${key.split('/').map(encodeURIComponent).join('/')}`;
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}

/**
 * Build a responsive `srcset` string for the given widths.
 */
export function imageSrcSet(key: string, widths: number[], opts: ImageTransformOptions = {}, base = ''): string {
  return widths.map((w) => `${imageUrl(key, { ...opts, width: w }, base)} ${w}w`).join(', ');
}
